import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const hasAppInitialized = createSelector(appSettingsState, (appSettings) => appSettings.hasInitialized);
